<template>
  <div :class="$style.base">
    <div>{{ counter }}</div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, useCssModule } from 'vue'
import { useAppStore } from '~/base/stores/app'
import { useDataLayerMixin } from '~/base/composables/useDataLayer'

const counter = ref(5)
const retries = ref(0)
const interval = ref<NodeJS.Timeout | null>(null)
const durations = ref([5, 10, 15])
const { eventDLPush } = useDataLayerMixin()
const { noScroll, bodyError } = useCssModule()

const appStore = useAppStore()

const props = defineProps({
  retry: { type: Function, required: true },
  retryFailed: { type: Function, required: true }
})

const countdownTimer = (): void => {
  interval.value = setInterval(async () => {
    counter.value--
    if (counter.value < 0 && interval.value) {
      clearInterval(interval.value)
      if (appStore.requestState.error) {
        console.log('verbindung-aktualisieren-' + retries.value)
        await eventDLPush(
          'verbindung-aktualisieren-' + retries.value,
          'reloadevent',
          'fehler'
        )
        await props.retry()
        await countdownTimerInit()
      }
    }
  }, 1000)
}

const countdownTimerInit = async (): Promise<void> => {
  if (retries.value < durations.value.length) {
    counter.value = durations.value[retries.value++]
    await countdownTimer()
  } else {
    await props.retryFailed()
  }
}

onMounted(async (): Promise<void> => {
  document.body.classList.add(noScroll, bodyError)
  await countdownTimerInit()
})

onUnmounted(() => {
  document.body.classList.remove(noScroll, bodyError)
})
</script>

<style module>
.base {
  border: 2px solid var(--color-white);
  border-radius: 100%;
  font-size: 18px;
  line-height: 22px;
  height: 45px;
  width: 45px;
  display: grid;
  margin: var(--space-xs) auto;
  position: relative;

/* TODO: check options for dynamic min width property */
@media screen and (min-width: 1025px) {
    margin: 24px auto;
  }

  & > * {
    align-self: center;
  }
}

.noScroll {
  height: 100vh;
  overflow: hidden;
}

.bodyError {
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: fixed;
    background: white;
    opacity: 0.7;
    z-index: 25;

    /* TODO: check options for dynamic min width property */
    @media screen and (min-width: 740px) {
      top: var(--layout-header-height-desktop);
    }
  }
}
</style>
